export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "sima-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "sima-themeWrapLive" */'./LiveThemeImporter'),
  },
};
